import { accentPalette } from "./tokens";

export type AccentName = keyof typeof accentPalette;

/**
 * Accent families don't all carry the same variant set — e.g. `magenta`
 * omits `muted` while `success` includes it. Using
 * `keyof (typeof accentPalette)[AccentName]` collapses to the intersection
 * of keys across every family, which then rejects valid per-family slots.
 * Keep the inner map as `Record<string, string>` and lean on the
 * `--token-accent-<family>-<variant>` CSS variable chain: a missing
 * variant resolves to undefined at runtime rather than being caught by tsc.
 */
export type AccentTokenName = string;

const formatAccentVar = (accent: string, token: string) =>
  `var(--token-accent-${accent}-${token.replace(/_/g, "-")})`;

export const accentVars = Object.fromEntries(
  Object.entries(accentPalette).map(([accentName, tokens]) => [
    accentName,
    Object.fromEntries(
      Object.keys(tokens)
        .filter((tokenName) => tokenName !== "description")
        .map((tokenName) => [tokenName, formatAccentVar(accentName, tokenName)]),
    ),
  ]),
) as Record<AccentName, Record<string, string>>;

export const getAccentVar = (accent: AccentName, token: AccentTokenName) =>
  accentVars[accent][token];
